/* eslint-disable max-len */
/*
 *  PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2025 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for FooterInfoIcon
 *
 * @author Anuja Gaikwad
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FooterInfoIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 16 16"
    fontSize="inherit"
  >
    <path
      d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 1.55556C4.44083 1.55556 1.55556 4.44083 1.55556 8C1.55556 11.5592 4.44083 14.4444 8 14.4444C11.5592 14.4444 14.4444 11.5592 14.4444 8C14.4444 4.44083 11.5592 1.55556 8 1.55556ZM8.44444 6.22222C8.68991 6.22222 8.88889 6.42121 8.88889 6.66667V12C8.88889 12.2455 8.68991 12.4444 8.44444 12.4444H7.55556C7.3101 12.4444 7.11111 12.2455 7.11111 12V6.66667C7.11111 6.42121 7.3101 6.22222 7.55556 6.22222H8.44444ZM8.44444 3.55556C8.68991 3.55556 8.88889 3.75454 8.88889 4V4.88889C8.88889 5.13435 8.68991 5.33333 8.44444 5.33333H7.55556C7.3101 5.33333 7.11111 5.13435 7.11111 4.88889V4C7.11111 3.75454 7.3101 3.55556 7.55556 3.55556H8.44444Z"
      fill="#5D5D5D"
    />
  </SvgIcon>
);

export default FooterInfoIcon;
